import { NavigationGuardNext, Route } from 'vue-router'
import store from '@/store'
import { IS_USER_LOGGED_IN, USER_LOGGED_IN } from '@/store/getter-types'
import { CurrentUser } from '@/model/CurrentUser'

export const rootPageGuard = (to: Route, from: Route, next: Function): void => {
  if (store.getters[IS_USER_LOGGED_IN]) {
    next('/dashboard')
  } else {
    next('/login')
  }
}

export const loginPageGuard = (to: Route, from: Route, next: Function): void => {
  if (store.getters[IS_USER_LOGGED_IN]) {
    next('/dashboard')
  } else {
    next()
  }
}

export const isUserLoggedInGuard = (to: Route, from: Route, next: Function): void => {
  if (store.getters[IS_USER_LOGGED_IN]) {
    next()
  } else {
    next('/login')
  }
}

export const tenantRedirectionGuard = (to: Route, from: Route, next: NavigationGuardNext): void => {
  if (to.name === 'RedirectToNewAddress') {
    next()
  } else {
    let getSubdomain = function (input?: string): string | null {
      const BASE_DOMAINS = ['pozrimenu.sk', 'lunchmenu.today', 'localhost']

      let hostname = ""

      if (!input) {
        hostname = window.location.hostname
      } else {
        try {
          hostname = new URL(input).hostname
        } catch {
          hostname = input
        }
      }

      // Normalize
      hostname = hostname.toLowerCase().replace(/\.$/, "") // drop trailing dot
      hostname = hostname.replace(/^www\./, "")            // remove www prefix

      // Check against all supported base domains
      for (const base of BASE_DOMAINS) {
        const m = hostname.match(
          new RegExp(`^([a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)\\.${base}$`)
        )
        if (m) {
          return m[1]
        }
        if (hostname === base) {
          return null // no subdomain present
        }
      }

      return null
    }

    if (store.getters[IS_USER_LOGGED_IN]) {
      let currentUser: CurrentUser = store.getters[USER_LOGGED_IN]
      let subdomain = getSubdomain()
      let tenantsToRedirect = [
        'stares-plus',
        'nortomlc'
      ]

      let tenantShouldRedirect = tenantsToRedirect.includes(currentUser.tenant.code)
      let subdomainShouldRedirect = subdomain === null;

      if (tenantShouldRedirect && subdomainShouldRedirect) {
        next('/redirect-to-new-address')
      } else {
        next()
      }
    } else {
      next()
    }
  }
}
